import type { PickerLocale } from "antd/es/date-picker/generatePicker"
import antdDatePickerLocale from "antd/es/date-picker/locale/en_US"
import dayjs from "lib/dayjs"

import { DATE_FORMATS } from "constants/dateFormats"

export const getLocalizedDatePickerLocale = (): PickerLocale => ({
  ...antdDatePickerLocale,
  lang: {
    ...antdDatePickerLocale.lang,
    locale: dayjs.locale(),
    fieldDateFormat: DATE_FORMATS.LOCALIZED_DATE,
  },
})
